module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.XeroLogoResized-b9723645814db816ea14a7226f264b3e.png";